import React, { useState, useEffect } from "react";
import Appointment from "../HomeMain/Appointment";
import Bredcrumb from "../HomeMain/Bredcrumb";
import Map from "../Mencontact/Map";
import axios from "axios";
import { baseURL, kullaniciId } from "../../App";

import { useGlobalState } from "../../useGlobalState";


const Main = () => {
  const { globalState, setGlobalState } = useGlobalState();

  const [iletisim, setIletisim] = useState([]);

  const fetchContactData = async () => {
    try {
      const response = await axios.get(`${baseURL}items/iletisim?fields=*.*&filter[kullanici][_eq]=${kullaniciId}`);
      // Verinin doğru formatta olup olmadığını kontrol et
      if (response.data) {
        // Veriyi state'e set etme
        setIletisim(response.data.data);
      } else {
        console.error("Invalid data format received from Directus.");
      }
    } catch (error) {
      console.error("Error fetching data from Directus:", error);
    }
  };


  useEffect(() => {
    fetchContactData();
  }, []);

  return (
    <>
      {iletisim && iletisim[0]?.translations?.filter(e => e.languages_code === globalState.lang)[0] && (

        <Bredcrumb title={iletisim && iletisim[0].translations?.filter(e => e.languages_code == globalState.lang)[0]?.sayfa_basligi}
          subtitle={iletisim && iletisim[0].translations?.filter(e => e.languages_code == globalState.lang)[0]?.baslik_2}
          breadcrumb_resim={`${baseURL}assets/${iletisim[0].sayfa_kapak?.id}`}

        />

      )}
      <Appointment />
      <Map />
    </>
  );
};

export default Main;
